import React,{useEffect} from "react";

const Signup = ({ setErrorMessage, setFormData, formData, toggleForm }) => {

  useEffect(() => {
    document.title = "Hello, New user"; // Set the title to "Login - My App"
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.password || !formData.confirm_Password) {
      setErrorMessage("Password and confirm password cannot be empty.");
      return;
    }

    if (formData.password !== formData.confirm_Password) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    const newUser = {
      name: formData.name,
      email: formData.email,
      password: formData.password,
    };

    // Get the number of current users by checking the keys that start with "data"
    const userCount = Object.keys(localStorage).filter((key) => key.startsWith("data")).length;

    // Create a new key for the new user
    const newUserKey = `data${userCount + 1}`;

    // Store the new user under this unique key
    localStorage.setItem(newUserKey, JSON.stringify(newUser));

    alert("Registration successful!");
    toggleForm(); // Toggle form back to login after successful registration
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="input-group">
        <label htmlFor="name">Name</label>
        <input
          type="text"
          id="name"
          placeholder="Enter your name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
      </div>

      <div className="input-group">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          placeholder="Enter your email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
      </div>

      <div className="input-group">
        <label htmlFor="password">Password</label>
        <input
          type="password"
          id="password"
          placeholder="Enter your password"
          value={formData.password}
          onChange={(e) => setFormData({ ...formData, password: e.target.value })}
        />
      </div>

      <div className="input-group">
        <label htmlFor="confirm-password">Confirm Password</label>
        <input
          type="password"
          id="confirm_Password"
          placeholder="Confirm your password"
          value={formData.confirm_Password}
          onChange={(e) => setFormData({ ...formData, confirm_Password: e.target.value })}
        />
      </div>

      <button type="submit" className="auth-button">Register</button>
    </form>
  );
};

export default Signup;